/**
 * Transforms an Auxo asset CDN URL with Cloudflare on-the-fly image optimization.
 * Rule 8: NEVER double-wrap, ALWAYS use format=auto, appropriate width.
 */
export function getOptimizedImageUrl(url, options = {}) {
  if (!url || typeof url !== 'string') return ''
  if (!url.startsWith('https://assets.auxodev.dk')) return url
  if (url.includes('/cdn-cgi/image/')) return url

  const { width = 800, quality = 80, fit = 'cover', height } = options
  const params = [`width=${width}`, `quality=${quality}`, 'format=auto']
  if (height) {
    params.push(`height=${height}`, `fit=${fit}`)
  }

  const prefix = 'https://assets.auxodev.dk/'
  const path = url.slice(prefix.length)
  return `https://assets.auxodev.dk/cdn-cgi/image/${params.join(',')}/${path}`
}
